/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlOption } from './ControlOption';
import {
    ControlOptionFromJSON,
    ControlOptionFromJSONTyped,
    ControlOptionToJSON,
    ControlOptionToJSONTyped,
} from './ControlOption';

/**
 * Available values for each control, keyed by control key.
 * @export
 * @interface DashboardOptionsResponse
 */
export interface DashboardOptionsResponse {
    /**
     * Selectable options for each control, keyed by control key
     * @type {{ [key: string]: Array<ControlOption>; }}
     * @memberof DashboardOptionsResponse
     */
    options?: { [key: string]: Array<ControlOption>; };
    /**
     * Selection each control should open on, keyed by control key. A control absent from this mapping has no default. Presentational only: the render endpoint applies the same default itself, so a client that ignores this renders the same dashboard and merely shows a blank picker.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DashboardOptionsResponse
     */
    defaultSelections?: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the DashboardOptionsResponse interface.
 */
export function instanceOfDashboardOptionsResponse(value: object): value is DashboardOptionsResponse {
    return true;
}

export function DashboardOptionsResponseFromJSON(json: any): DashboardOptionsResponse {
    return DashboardOptionsResponseFromJSONTyped(json, false);
}

export function DashboardOptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardOptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'options': json['options'] == null ? undefined : json['options'],
        'defaultSelections': json['default_selections'] == null ? undefined : json['default_selections'],
    };
}

export function DashboardOptionsResponseToJSON(json: any): DashboardOptionsResponse {
    return DashboardOptionsResponseToJSONTyped(json, false);
}

export function DashboardOptionsResponseToJSONTyped(value?: DashboardOptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'options': value['options'],
        'default_selections': value['defaultSelections'],
    };
}

